module.exports = __webpack_public_path__ + "img/icon-expand.e60bdf53.svg";